import React from 'react'
import {
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Box,
  Button,
  TablePagination,
  CircularProgress,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import Tooltip from '@mui/material/Tooltip'
import { toast } from 'react-toastify'
import EditIcon from '@mui/icons-material/Edit'
import { updateLastActive } from '../../utils/templatesApi'

const TemplatesList = ({
  onSelect,
  onDelete,
  role,
  Options,
  page,
  rowsPerPage,
  totalCount,
  handleChangePage,
  handleChangeRowsPerPage,
  setPage,
  loading,
  setLoading,
  userId,
}) => {
  const handleDelete = item => {
    setLoading(true)
    onDelete(item)
      .then(() => {
        toast.success('Template deleted successfully')
        if (Options.length === 1 && page > 0) {
          setPage(prev => prev - 1) // Move to previous page
        }
      })
      .catch(() => {
        toast.error('Failed to delete template')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer
            sx={{
              mt: 2,
              minWidth: '80vw',
              maxHeight: '70vh',
              overflow: 'auto',
            }}
          >
            <Table aria-label='customized table'>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: '#111827',
                    position: 'sticky',
                    top: 0,
                  }}
                >
                  <TableCell sx={{ color: 'white' }}>Template Name</TableCell>
                  <TableCell sx={{ color: 'white' }}>Category Name</TableCell>
                  <TableCell sx={{ color: 'white' }}>Subject</TableCell>
                  <TableCell sx={{ color: 'white' }}>Users</TableCell>
                  <TableCell sx={{ color: 'white', textAlign: 'right' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Options?.length > 0 ? (
                  Options.map(template => (
                    <TableRow key={template.id}>
                      <TableCell>{template.name}</TableCell>
                      <TableCell>
                        {template.category?.category_name ?? 'N/A'}
                      </TableCell>
                      <TableCell>{template.subject}</TableCell>

                      <TableCell>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                          {template.users?.slice(0, 2).map(user => (
                            <Chip
                              key={user.id}
                              label={user.first_name}
                              size='small'
                              sx={{
                                backgroundColor: '#E3F2FD',
                                color: '#0D47A1',
                                fontWeight: 500,
                              }}
                            />
                          ))}

                          {template.users?.length > 2 && (
                            <Tooltip
                              title={
                                <Box>
                                  {template.users.slice(2).map(user => (
                                    <Typography key={user.id} variant='body2'>
                                      {user.first_name}
                                    </Typography>
                                  ))}
                                </Box>
                              }
                            >
                              <Chip
                                label={`+${template.users.length - 2} more`}
                                size='small'
                                sx={{
                                  backgroundColor: '#FFF3E0',
                                  color: '#EF6C00',
                                  fontWeight: 500,
                                  cursor: 'pointer',
                                }}
                              />
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>

                      <TableCell sx={{ textAlign: 'right' }}>
                        {role === 'admin'|| role === 'super-admin' ? (
                          <Grid
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              gap: 1,
                            }}
                          >
                            <Tooltip title='Edit'>
                              <Grid
                                onClick={() => {
                                  onSelect(template)
                                  updateLastActive(userId, new Date())
                                }}
                              >
                                <EditIcon
                                  sx={{ cursor: 'pointer', color: '#1976d2' }}
                                />
                              </Grid>
                            </Tooltip>
                            <Tooltip title='Delete'>
                              <Grid
                                onClick={() => {
                                  handleDelete(template)
                                  updateLastActive(userId, new Date())
                                }}
                              >
                                <DeleteIcon
                                  sx={{ cursor: 'pointer', color: '#e53935' }}
                                />
                              </Grid>
                            </Tooltip>
                          </Grid>
                        ) : (
                          <Button
                            onClick={() => {
                              onSelect(template)
                              updateLastActive(userId, new Date())
                            }}
                            variant='contained'
                            sx={{ textTransform: 'capitalize' }}
                          >
                            View
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography textAlign='center'>
                        There is no template found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component='div'
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </>
  )
}

export default TemplatesList
